<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input (click)="datePicker.open()" [formControl]="date"
           [mtxDatetimepicker]="datePicker" matInput placeholder="Filter" readonly>
    <mtx-datetimepicker #datePicker [multiYearSelector]="true"></mtx-datetimepicker>
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
